import { Component, OnInit, Input, ViewChild, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

import { Seller } from 'src/app/classes/seller.class';
import { Grade } from 'src/app/classes/grade.class';

import Swal from 'sweetalert2';
@Component({
  selector: 'app-table-users',
  templateUrl: './table-users.component.html',
  styleUrls: ['./table-users.component.scss']
})
export class TableUsersComponent implements OnInit {

  @Input() userType : string;
  @Input() sellerList:Seller[]=[];
  @Input() grades : string;
  @Input() order : string;
  @Input() orderM : string;

  @Output() deleteEvent : EventEmitter<Seller> = new EventEmitter<Seller>();
  @Output() toggleStatusEvent : EventEmitter<Seller> = new EventEmitter<Seller>();

  displayedColumns = ['seller_name','seller_email', 'seller_phonenumber', 'action'];
  dataSource: MatTableDataSource<Seller>;

  sellerDataSource: MatTableDataSource<Seller>;
  sellers: Seller[]=[];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  paddingColumnsResponsive: boolean;

  constructor() {
    this.sellerDataSource = new MatTableDataSource(this.sellerList);
  }

  ngOnChanges(changes: SimpleChanges) : void {
    console.log(this.sellerList);

    if (changes['sellerList'] != null) {
      this.sellerDataSource.data = this.sellerList;
      this.sellerDataSource.paginator = this.paginator;
      this.sellerDataSource.sort = this.sort;
    }
  }

  ngOnInit(): void {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.paddingColumnsResponsive = true; 
    }else{
      this.paddingColumnsResponsive = false; 
    }
  }

  deleteEventTrigger(seller : Seller) {
    this.deleteEvent.emit(seller);
  }

  toggleStatusEventTrigger(seller : Seller) {
    this.toggleStatusEvent.emit(seller);
  }

}
